// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"b4d60eef","142":"4beaa587","222":"98f594b3","423":"7fcb4c51","498":"c11cbe86","570":"072ca48b","695":"3771cd98","721":"1ca5c471","835":"298f2cba"}[chunkId] + ".chunk.css";
};